module.exports = __webpack_public_path__ + "static/media/logo_login_old.85b29e0a.png";